/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */

import type { DataResponse_SubscriptionStatusResponse_ } from "../models/DataResponse_SubscriptionStatusResponse_";
import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";
export class SubscriptionsService {
  /**
   * Get Subscription Status
   * Get the current user's subscription status.
   *
   * Returns subscription information including:
   * - is_active: Whether the user has an active subscription
   * - is_expired: Whether the subscription has expired
   * - status: Current status (active, cancelled, expired, trial, billing_issue, none)
   * - subscription_type: monthly, yearly, or free
   * - expired_at: Expiration date in ISO 8601 UTC
   *
   * Returns:
   * DataResponse with SubscriptionStatusResponse
   * @param xUserId
   * @returns DataResponse_SubscriptionStatusResponse_ Successful Response
   * @throws ApiError
   */
  public static getSubscriptionStatusApiV1SubscriptionsStatusGet(
    xUserId: string,
  ): CancelablePromise<DataResponse_SubscriptionStatusResponse_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/subscriptions/status",
      headers: {
        "x-user-id": xUserId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Start Free Trial
   * Start a 7-day free trial for the current user.
   *
   * One free trial per user. Returns 409 if the user already used their trial
   * or has an active subscription.
   *
   * Returns:
   * DataResponse with SubscriptionStatusResponse
   * @param xUserId
   * @returns DataResponse_SubscriptionStatusResponse_ Successful Response
   * @throws ApiError
   */
  public static startFreeTrialApiV1SubscriptionsTrialPost(
    xUserId: string,
  ): CancelablePromise<DataResponse_SubscriptionStatusResponse_> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/subscriptions/trial",
      headers: {
        "x-user-id": xUserId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Verify Subscription
   * Verify subscription status by calling RevenueCat REST API.
   *
   * Called by the frontend immediately after a purchase to sync the backend
   * before the webhook arrives. Updates DynamoDB with the live subscription
   * state from RevenueCat and returns the fresh status.
   *
   * Returns:
   * DataResponse with SubscriptionStatusResponse
   * @param xUserId
   * @returns DataResponse_SubscriptionStatusResponse_ Successful Response
   * @throws ApiError
   */
  public static verifySubscriptionApiV1SubscriptionsVerifyPost(
    xUserId: string,
  ): CancelablePromise<DataResponse_SubscriptionStatusResponse_> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/subscriptions/verify",
      headers: {
        "x-user-id": xUserId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
